/**
 * Display label for audit fields (payment override, Liberty bypass, etc.)
 * from Redux auth userdetails.
 */
export function formatAuditActorLabel(userdetails) {
  if (userdetails?.first_name && userdetails?.last_name) {
    return `${userdetails.first_name} ${userdetails.last_name}`;
  }
  if (userdetails?.email) {
    return userdetails.email;
  }
  return "Unknown";
}
